<template>
    <div>
        <b-modal :active.sync="credsModal" scroll="keep" :can-cancel="false">
            <b-loading :is-full-page="false" :active.sync="prodDetailLoading" :can-cancel="true"></b-loading>
            <div class="modal-card modal-creds" >
                <div class="modal-card-body">
                    <div class="has-text-right">
                        <a 
                        @click="emitClose"
                        class="has-text-danger m-b-10">
                            <b-icon icon="times" class="m-l-5"></b-icon>Cerrar
                        </a>
                    </div>
                    <b-field label="ID cliente" label-position="on-border">
                        <b-input
                        v-model="details.bambooClientId">
                        </b-input>
                    </b-field>
                    <b-field label="Llave 3DES" label-position="on-border">
                        <b-input
                        v-model="details.bambooKey">
                        </b-input>
                    </b-field>


                    <div class="has-text-centered">
                        <b-button
                        type="is-primary has-text-centered"
                        rounded
                        :loading="loadingBtn"
                        @click="saveDetails">
                            <b-icon icon="save" size="is-small"></b-icon>
                            Guardar
                        </b-button>
                    </div>

                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { getHandler, patchHandler, postHandler } from '../../../../services/http'
export default {
    props:{
        details:{
            type:Object,
            default:new Object({})
        },
        credsModal:{
            type:Boolean,
            default:""
        }
    },
    data(){
        return {
            loading:false,
            loadingBtn:false,
        }
    },
    methods:{
        emitClose(){
            this.$emit("closeModal")
        },
        
        saveDetails(){
            this.$emit("updateCompany", this.details)
            this.emitClose()
        }
    },

}
</script>

<style lang="scss" scoped>

.modal-creds{
    border-radius: 20px;
    width:auto;
}

</style>